module.exports = __webpack_public_path__ + "static/media/shopping-bag.aed8a137.png";